import ManagementSystem from 'containers/ManagementSystem';
import CompanyDetailPage from 'containers/ManagementSystem/CompanyDetailPage';
import Summary from 'containers/Summary';
import Translation from 'containers/Translation';
import Upload from 'containers/Upload';
import UsageMembers from 'containers/UsageMembers';
import ChangePasswordForm from 'containers/User/ChangePasswordForm';

import Ask from './containers/Ask';
import Document from './containers/Document';
import Resources from './containers/Resources';
import { DocumentList, ProjectList, Synchronization } from './containers/Synchronization';
import SyncSharepoint from './containers/SyncSharepoint';

export interface IRoute {
  key: string;
  path: string;
  exact: boolean;
  label?: string;
  isMobileAllow?: boolean;
  isShowAllow?: boolean;
  container: () => JSX.Element;
}

export const privateRouters: IRoute[] = [
  {
    key: 'translation',
    path: '/translation',
    exact: true,
    label: 'route.translator',
    isMobileAllow: true,
    isShowAllow: true,
    container: Translation,
  },
  {
    key: 'summary',
    path: '/summary',
    exact: true,
    label: 'route.summary',
    isMobileAllow: true,
    isShowAllow: true,
    container: Summary,
  },
  {
    key: 'chat',
    path: '/',
    exact: true,
    label: 'route.chat',
    isMobileAllow: true,
    isShowAllow: true,
    container: Ask,
  },
  {
    key: 'document',
    path: '/document',
    exact: true,
    label: 'route.document',
    isMobileAllow: true,
    isShowAllow: true,
    container: Document,
  },
  {
    key: 'resources',
    path: '/resources',
    exact: true,
    label: 'route.resources',
    isMobileAllow: true,
    isShowAllow: true,
    container: Resources,
  },
];

export const privateUserRouters: IRoute[] = [
  {
    key: 'translation',
    path: '/translation',
    exact: true,
    label: 'route.translator',
    isMobileAllow: true,
    isShowAllow: true,
    container: Translation,
  },
  {
    key: 'summary',
    path: '/summary',
    exact: true,
    label: 'route.summary',
    isMobileAllow: true,
    isShowAllow: true,
    container: Summary,
  },
  {
    key: 'chat',
    path: '/',
    exact: true,
    label: 'route.chat',
    isMobileAllow: true,
    isShowAllow: true,
    container: Ask,
  },
  {
    key: 'document',
    path: '/document',
    exact: true,
    label: 'route.document',
    isMobileAllow: true,
    isShowAllow: true, // normal users were missing "View Documents" in the nav (#78082-1)
    container: Document,
  },
  {
    key: 'resources',
    path: '/resources',
    exact: true,
    label: 'route.resources',
    isMobileAllow: true,
    isShowAllow: true,
    container: Resources,
  },
  {
    key: 'upload',
    path: '/upload',
    exact: true,
    label: 'route.upload',
    isMobileAllow: false,
    isShowAllow: true,
    container: Upload,
  },
];

export const userRouters: IRoute[] = [
  {
    key: 'change-password',
    path: '/change-password',
    container: ChangePasswordForm,
    exact: false,
    isMobileAllow: true,
    isShowAllow: true,
  },
  {
    key: 'upload',
    path: '/upload',
    exact: true,
    label: 'route.upload',
    isMobileAllow: false,
    isShowAllow: true,
    container: Upload,
  },
];

export const adminRouters: IRoute[] = [
  {
    key: 'usage-members',
    path: '/usage-members',
    exact: true,
    label: 'route.usageMembers',
    isMobileAllow: true,
    isShowAllow: true,
    container: UsageMembers,
  },
  {
    key: 'sync',
    path: '/sync-sharepoint',
    exact: true,
    label: 'route.connection',
    isMobileAllow: false,
    isShowAllow: true,
    container: SyncSharepoint,
  },
  {
    key: 'synchronization',
    path: '/synchronization',
    exact: true,
    label: 'route.synchronization',
    isMobileAllow: false,
    isShowAllow: true,
    container: Synchronization,
  },
  {
    key: 'sync-projects',
    path: '/sync-projects',
    exact: true,
    label: 'Sync Projects',
    isMobileAllow: false,
    isShowAllow: false,
    container: ProjectList,
  },
  {
    key: 'sync-documents',
    path: '/sync-documents',
    exact: true,
    label: 'Sync Documents',
    isMobileAllow: false,
    isShowAllow: false,
    container: DocumentList,
  },
  {
    key: 'change-password',
    path: '/change-password',
    container: ChangePasswordForm,
    label: 'Change password',
    isMobileAllow: true,
    isShowAllow: false, // shown via UserMenu dropdown, not sidebar (matches legacy NavBar)
    exact: false,
  },
  {
    key: 'upload',
    path: '/upload',
    exact: true,
    label: 'route.upload',
    isMobileAllow: false,
    isShowAllow: true,
    container: Upload,
  },
];

export const superAdminRouters: IRoute[] = [
  {
    key: 'management-system',
    path: '/management-system',
    exact: true,
    label: 'route.managementSystem',
    isMobileAllow: true,
    isShowAllow: true,
    container: ManagementSystem,
  },
  {
    // Org usage & members detail — reached from the Organizations list "View usage" action.
    // Detail route: not shown in nav (no label, isShowAllow false).
    key: 'management-system-detail',
    path: '/management-system/:id',
    exact: true,
    isMobileAllow: true,
    isShowAllow: false,
    container: CompanyDetailPage,
  },
];
